import { render, staticRenderFns } from "./OrganizationNavFragment.vue?vue&type=template&id=03f75522&scoped=true&"
import script from "./OrganizationNavFragment.vue?vue&type=script&lang=js&"
export * from "./OrganizationNavFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f75522",
  null
  
)

export default component.exports